$(function() {
  var fadeDist = 300;

  var els = Array.prototype.slice.call(document.querySelectorAll("[data-parallax-layer]"));
  for (var i = 0; i < els.length; i++) update(els[i]);

  function update(el) {
    var scrollY = window.pageYOffset || 0;
    var layer = parseFloat(el.getAttribute("data-parallax-layer"));
    var fade = el.hasAttribute("data-parallax-fade");
    var speed = 1 / layer;
    var offset = scrollY * speed;
    el.style.transform = "translateY(" + (offset.toFixed(0)) + "px)";
    if(fade) el.style.opacity = Math.max(0, fadeDist - scrollY) / fadeDist;
  }

  function onScroll() {
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      update(el);
    }
  }

  window.addEventListener("scroll", onScroll, { passive: false });
});
